goog.provide("shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg$default");
shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg$default = shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg.default;
